<template>
  <div>
    <div style="position:fixed; width:100%; z-index:1000">
      <b-navbar class="navbar-bg" toggleable="sm"
                fixed="top" :sticky="true">
        <b-navbar-brand to="/" class="mr-0">
          <img src="@/assets/img/logo-kakaogames.svg"
               class="logo_kakaogames">
          <div
            style="display: inline-block; width: 1px; height: 14px; opacity: 0.2; background-color: #000000; margin: 0 13px 0 13px;"></div>
          <span class="navbar-title" :class="{'text-black-50':isInhousePage}">광고주 센터</span>

        </b-navbar-brand>
        <b-navbar-brand :to="firstInhousePage" class="ml-0">
          <span v-if="getAuthType==='LDAP'">
            <div
              style="display: inline-block; width: 1px; height: 14px; opacity: 0.2; background-color: #000000; margin: 0 13px 0 13px;"></div>
            <span class="navbar-title"
                  :class="{'text-black-50':!isInhousePage}">광고주 센터 inhouse</span>
          </span>
        </b-navbar-brand>
        <b-navbar-nav class="ml-auto">

          <b-navbar-brand v-if="0<=guideMenuAuthLevel" to="/guide">
            <i class="fas fa-download"></i>
            가이드
            <i v-if="newDownload"
               class="fas fa-circle" style="color: red; font-size: 10px; vertical-align: top;"></i>
          </b-navbar-brand>
          <b-nav-item-dropdown v-if="getAuth" :no-caret="true" right>
            <template v-slot:button-content>
              <div v-if="getAuth">
                <span class="navbar-account-button-text">
                  <span v-if="getAuthType==='LDAP'">
                    {{getAuth.accountId}}
                    <div class="small-seperator"></div>
                    {{getAuth.personName}}
                    <div class="my-account-eval-with-arrow">
                      <i class="ico_down"></i>
                    </div>
                  </span>

                  <span v-if="getAuthType==='KAKAO'">
                    <span v-if="getUser">
                      {{getUser.idpId}}
                      <div class="small-seperator"></div>
                      {{getUser.name}}
                    </span>
                    <span v-else>
                      {{getKakaoEmail}}
                    </span>
                    <div class="my-account-eval-with-arrow">
                      <i class="ico_down"></i>
                    </div>
                  </span>
                </span>
              </div>
            </template>

            <div v-if="adminUserMenu">
              <b-dropdown-item v-for="lowerMenu in adminUserMenu.lowerMenuList"
                               @click="twoDepthMenuClicked(lowerMenu)">{{lowerMenu.name}}
              </b-dropdown-item>
            </div>

            <div v-if="adminManagementMenu">
              <b-dropdown-divider v-if="adminUserMenu" />
              <b-dropdown-item v-for="lowerMenu in adminManagementMenu.lowerMenuList"
                               @click="twoDepthMenuClicked(lowerMenu)">{{lowerMenu.name}}
              </b-dropdown-item>
            </div>

            <b-dropdown-divider></b-dropdown-divider>

            <b-dropdown-item @click="logout">로그아웃</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-navbar>
      <b-navbar v-if="isTopBarVisible" class="navbar-bg2 p-0" toggleable="sm">
        <b-navbar-nav>
          <div class="navbar-ad-account-selector-bg">
            <b-nav-item-dropdown v-if="!!getAuth"
                                 :lazy='true'
                                 class="navbar-ad-account-selector navbar-item-text"
                                 toggle-class="truncate-170"
                                 :text="adAccountSelectorText">
              <b-dropdown-header>
                내 광고계정 목록
              </b-dropdown-header>
              <div class="my-ad-account-list-container">
                <b-dropdown-form form-class="pl-2 pr-2">
                  <b-form-input
                    v-model="filteringAccountName"
                    size="sm"
                    autofocus
                    placeholder="광고계정 검색"
                    autocomplete="off"
                  ></b-form-input>
                </b-dropdown-form>
                <b-dropdown-item v-for="adAccount in sortedAdAccountList" v-bind:key="adAccount.id"
                                 link-class="truncate-200"
                                 @click="adAccountItemClicked(adAccount.id)">
                  <span v-if="!isProduction">{{adAccount.id}} : </span>{{adAccount.name}}
                </b-dropdown-item>
              </div>
              <b-dropdown-text v-show="sortedAdAccountList.length==0">검색결과가 없습니다.</b-dropdown-text>
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-header>
                광고계정 관리
              </b-dropdown-header>
              <b-dropdown-item v-if="!!getMenuByPath('/user/management/ad-account')"
                               :to="{name:'MyAdAccountManagement'}">
                내 광고계정 전체보기 ( {{getAuthType==="KAKAO" ? getAdAccountList.length :
                getLdapAdAccountList.length}} )
              </b-dropdown-item>
              <b-dropdown-item v-if="!!getMenuByPath('/user/management/ad-account')"
                               :to="{name:'StartAdAccount'}">
                새 광고계정 만들기
              </b-dropdown-item>
              <b-dropdown-item :to="{name:'AdAccountInformation'}">광고계정 관리</b-dropdown-item>
            </b-nav-item-dropdown>
          </div>
          <b-nav-item-dropdown class="one-depth-menu" v-for="menu in menusExceptNavButtonMenus"
                               v-bind:key="menu.id"
                               :text="menu.name">
            <b-dropdown-item v-for="lowerMenu in menu.lowerMenuList"
                             @click="twoDepthMenuClicked(lowerMenu)">{{lowerMenu.name}}
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-navbar>
    </div>

    <div class="content-body" :class="{'no-topbar':!isTopBarVisible}">
      <div class="side-nav" :class="{'no-sidebar':menuRouterBinded, 'no-topbar':!isTopBarVisible}">
        <default-menu v-if="!menuRouterBinded">

        </default-menu>
        <router-view name="menu">
        </router-view>
      </div>

      <div class="h-100">
        <div id="main" class="main"
            :class="{'no-sidebar':menuRouterBinded, 'no-topbar':!isTopBarVisible}">
          <div class="d-flex justify-content-between">
            <div v-if="currentMenuOrMenuTitle" class="page-title">
              {{typeof currentMenuOrMenuTitle === 'string' ? currentMenuOrMenuTitle : currentMenuOrMenuTitle.name}}
            </div>
            <draw-guide-download class="ml-auto">
            </draw-guide-download>
          </div>
          <router-view class="position-relative" :key="$route.path">
          </router-view>
        </div>
      </div>


    </div>

    <footer id="main-footer" :class="{'no-sidebar':menuRouterBinded}">
      <div>
        <span class="copyright-kakaogames float-right" :title="buildTime">
          Copyright ⓒ Kakao Corp. All right reserved.
        </span>
        <span class="footer-left-content">
          <a href="https://web-data-cdn.kakaogames.com/real/www/html/terms/index.html?service=S0010&type=T001&country=kr&lang=ko" target="_blank" class="ml-3">
            이용약관
          </a>
          <div class="small-seperator"></div>
          <a href="https://business.kakao.com/policy/privacy/" target="_blank">
            <b>개인정보처리방침</b>
          </a>
          <div class="small-seperator"></div>
          <router-link to="#" @click.native="showNoticeModal"><b>공지사항</b></router-link>
        </span>
      </div>
    </footer>
  </div>
</template>

<script>
  import {mapMutations, mapActions, mapGetters} from 'vuex';
  import DefaultMenu from "@/components/main/DefaultSideMenu";
  import DrawGuideDownload from "@/components/main/DrawGuideDownload";
  import {gapDefaultSort} from "@/util/sort";
  import s3Api from "../api/s3Api";
  import {platformGuideDirectory} from "../model/guideFile";
  import moment from "moment";

  const openPrivacyPolicy = function (e) {
    if (e.data === "openPrivacyPolicy") {
      this.showPrivacyPolicyModal();
    }
  };

  export default {
    name: 'Main',
    components: {
      DefaultMenu,
      DrawGuideDownload,
    },
    data() {
      return {
        menuRouterBinded: false,
        currentMenu: null,
        newDownload: false,
        filteringAccountName: "",

        buildTime: process.env.VUE_APP_BUILD_TIME
      };
    },
    created() {
      this.refreshAdAccountList();
      this.refreshAdminMenu();
    },
    mounted() {
      this.refreshMenuRouterBinded();

      window.addEventListener("message", openPrivacyPolicy.bind(this));

      s3Api.getList(platformGuideDirectory).then(response => {
        const nowMoment = moment();
        response?.data.forEach(
          elm => {
            if (elm.key.endsWith('/'))
              return; //directory skip
            if (moment(elm.lastModifiedAt).diff(nowMoment, "day") >= -7) {
              this.newDownload = true;
            }
          }
        )
      });
    },
    computed: {
      isTopBarVisible() {
        return !!this.getAuth &&
               !this.$route.matched.some(elm => elm.meta.noAdAccountSelector === true)
      },
      adAccountSelectorText() {
        return this.selectedAdAccount ? this.selectedAdAccount.name : '광고계정을 선택하세요';
      },
      adminUserMenu() {
        return this.getMenus.find(elm => elm.url === '/user');
      },
      adminManagementMenu() {
        return this.getMenus.find(elm => elm.url === '/admin');
      },
      menusExceptNavButtonMenus() {
        const exceptMenus = ['/admin', '/user', '/guide'] //광고계정 선택기 오른쪽에서 제외되는 메뉴들 (어드민관리, 내정보, 가이드)
        return this.getMenus.filter(elm => exceptMenus.every(exceptMenu => elm.url !== exceptMenu));
      },
      guideMenuAuthLevel() {
        const authLevel =
          this.getMenus.find(elm => elm.url === '/guide')?.lowerMenuList[0]?.lowerMenuList[0]?.authLevel;
        return typeof authLevel === 'number' ? authLevel : -1;
      },
      isProduction() {
        return process.env.NODE_ENV === "production";
      },
      currentMenuOrMenuTitle() {
        return this.getPageTitle || this.currentMenu;
      },
      sortedAdAccountList() {
        this.getAdAccountList.sort((a, b) => gapDefaultSort(a.name, b.name));
        return this.getAdAccountList?.filter(elm => elm.name.includes(this.filteringAccountName));
      },
      isInhousePage() {
        return this.getCurrentMenu?.upperMenu?.upperMenu?.url === '/admin' || false;
      },
      firstInhousePage() {
        return this.getMenus.find(
          menu => menu.url === '/admin')?.lowerMenuList[0]?.lowerMenuList[0].url || "/";
      },


      ...mapGetters(
        [
          'getAuth', 'getUser', 'getAuthType', 'getMenus', 'getAdAccountList',
          'getLdapAdAccountList', 'selectedAdAccount',
          'getKakaoEmail', 'getPageTitle', 'getMenuByPath', 'getCurrentMenu'
        ]
      )
    },
    methods: {
      async refreshMenuRouterBinded() {
        this.menuRouterBinded = (!!this.$route.matched.find(elm => !!elm.components.menu));
        this.currentMenu = this.getCurrentMenu;
      },
      adAccountItemClicked(id) {
        this.$router.push({name: "DashBoard", query: {adAccountId: id}})
          .finally(() => {
            this.refreshAdAccountList();
            this.refreshAdminMenu();
          });
      },
      twoDepthMenuClicked(menu) {
        if (menu && menu.lowerMenuList.length > 0) {
          this.$router.push(menu.lowerMenuList[0].url);
        }
      },
      showPrivacyPolicyModal() {
        this.$bvModal.show('modal-privacy-policy');
      },
      showNoticeModal() {
        this.$bvModal.show('modal-notice');
      },
      ...mapMutations(
        [
          'removeAuth', 'selectAdAccount', 'setPageTitle'
        ]
      ),
      ...mapActions(
        ['refreshAdAccountList', 'refreshAdminMenu', 'logout', 'getAdAccountDetail']
      )
    },
    watch: {
      '$route'(newVal, oldVal) {
        this.refreshMenuRouterBinded();
        if (this.$route.query.adAccountId) {
          this.selectAdAccount(parseInt(this.$route.query.adAccountId));
          this.$router.replace({path: '/', query: {}});
        }

        ///페이지 이동 시 page title 초기화, 권한 초기화를 위해 메뉴 새로 불러옴
        if (oldVal.path !== newVal.path) {
          this.setPageTitle(null);
          this.refreshAdminMenu();
        }
      },
      getMenus(newVal, oldVal) {
        this.refreshMenuRouterBinded();
      },
      selectedAdAccount(newVal, oldVal) {
        if (!newVal) {
          this.$router.push({name: 'DashBoard'});
        } else if (!newVal.detail) {
          this.getAdAccountDetail(this.selectedAdAccount.id);
        }
      }
    }
  };

</script>

<style lang="scss">
  $gnb-height: 70px;
  $ad-account-selector-height: 56px;
  $topbar-height: $gnb-height + $ad-account-selector-height;
  $side-nav-width: 220px;

  .navbar-brand {
    margin-left: 14px;
  }

  .navbar-title {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -1px;
    color: #222222;
  }

  .navbar-bg {
    background-color: #FFFFFF;
    height: $gnb-height;
  }

  .logo_kakaogames {
    width: 119px;
    height: 22px;
    object-fit: contain;
  }

  .navbar-account-button-text {
    font-size: 14px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: -0.5px;
    color: #222222;
  }

  .small-seperator {
    display: inline-block;
    width: 1px;
    height: 10px;
    opacity: 0.2;
    background-color: #000000;
    margin: 0 6px 0px 6px;
  }

  .my-account-eval-with-arrow {
    display: inline-block;
    width: 26px;
    height: 26px;
    border: solid 1px #E1E1E1;
    border-radius: 13px;
    text-align: center;
    margin: 0 0 0 10px;
  }

  .navbar-bg2 {
    background-color: #EEEEEE;
    white-space: nowrap;
    height: $ad-account-selector-height;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    /* IE10+ */
    .navbar-bg2 {
      background-color: #EEEEEE;
      white-space: nowrap;
      height: $ad-account-selector-height;
      top: $gnb-height;
    }
  }

  .navbar-ad-account-selector-bg {
    background: #F7F7F7;
    width: $side-nav-width;
    height: $ad-account-selector-height;
  }

  /* 좌측 상단 광고계정 선택 */
  .navbar-ad-account-selector > .dropdown-toggle > *,
  .navbar-ad-account-selector > .dropdown-toggle::after {
    //color: white;
  }

  .my-ad-account-list-container {
    max-height: 30vh;
    overflow-y: scroll;
    overflow-x: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .one-depth-menu,
  .navbar-ad-account-selector {
    margin-top: 10px;
    margin-left: 15px;
    width: 160px;
    height: 36px;
    object-fit: contain;
    border-radius: 2px;
    border: solid 1px #E1E1E1;
    background-color: #FFFFFF;
    padding-left: 5px;
  }

  .navbar-ad-account-selector {
    width: 188px;
  }

  .one-depth-menu.show,
  .navbar-ad-account-selector.show {
    border-color: #888888;
  }

  /* 1뎁스 메뉴 평상시 */
  .one-depth-menu > .dropdown-toggle > *,
  .navbar-ad-account-selector > .dropdown-toggle > * {
    color: #222222;
  }

  /* 1뎁스 메뉴 클릭시 */
  .one-depth-menu > a[aria-expanded="true"] > *,
  .navbar-ad-account-selector > a[aria-expanded="true"] > * {
    color: #222222;
  }

  /* 커스텀 화살표 */
  .one-depth-menu > .dropdown-toggle::after,
  .navbar-ad-account-selector > .dropdown-toggle::after {
    position: absolute;
    background-image: url("../assets/img/ico/ico-down.svg");
    width: 9px;
    height: 6px;
    object-fit: contain;
    top: 14px;
    right: 12px;
    border: 0;
  }

  .one-depth-menu + .one-depth-menu {
    margin-left: 1rem;
  }

  .one-depth-menu > ul,
  .navbar-ad-account-selector > ul {
    width: 160px;
    border-radius: 2px;
    border: solid 1px #888888;
    background-color: #FFFFFF;
    left: -1px;
  }

  .navbar-ad-account-selector > ul {
    width: 188px;
  }

  .dropdown-item:hover {
    background-color: #FFF8D9 !important;
  }

  .side-nav {
    position: fixed;
    width: $side-nav-width;
    height: calc(100% - 62px - #{$topbar-height});
    flex: 0 0 $side-nav-width;
    margin-bottom: 62px;
    z-index: 1;
  }

  .side-nav > * {
    height: 100%;
  }

  .side-nav.no-sidebar {
    width: 0px;
  }

  .side-nav.no-topbar {
    margin-top: 2px;
    height: calc(100% - 64px - #{$gnb-height});
  }


  /* 탑바 제외한 화면 */
  .content-body {
    padding-top: $topbar-height;
  }

  .content-body.no-topbar {
    padding-top: $gnb-height;
  }

  /* 탑바, 사이드바, 푸터 제외한 화면 */
  .main {
    background-color: #F7F7F7;
    position: fixed;
    padding: 1rem 2rem 0 calc(#{$side-nav-width} + 2rem);
    width: 100%;
    /* height : 100% - 탑바 height - 푸터 height */
    height: calc(100% - #{$topbar-height} - 60px);
    overflow-y: auto;
    z-index: 0;
  }

  /* main의 padding-bottom이 IE에서 적용이 안되어서 main after에 추가*/
  .main:after {
    display: block;
    height: 2rem;
    content: "";
  }

  .main.no-topbar {
    height: calc(100% - #{$gnb-height} - 60px);
  }

  .main.no-sidebar {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .no-sidebar {
    padding-left: calc(10px + 1rem);
    width: calc(100%);
  }

  #main-footer {
    background-color: #FFFFFF;
    color: #555555;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 60px;
    vertical-align: middle;
  }

  #main-footer > div > .copyright-kakaogames {
    position: absolute;
    right: 18px;
    bottom: 21px;
    font-size: 12px;
    color: #888888;
  }

  #main-footer > div > .footer-left-content {
    position: absolute;
    left: 30px;
    bottom: 21px;
    font-size: 12px;
    color: #888888;
  }

  #main-footer > div > .footer-left-content > a {
    color: #555555;
  }


</style>
